const colombia = (vm, row, data) => {
    const columna = 10;
    const host = vm.GLOBAL.SERVER_HOST;
    const empresa = vm.empresa;
    const td = $("td", row).eq(columna);

    if (data.estado == "G") {
        if (data.url_factura != null) {
            const viewPDF = $("<a class='btn btn-sm btn-danger' target='_blank' href='" + data.url_factura + "'><i class='fa-solid fa-file-pdf'></i> DIAN</a>");
            td.eq(columna).append(viewPDF);
        }
    }

    // PRE FACTURA Y EMITIR
    if (data.public_hasp == null && data.documento_id == vm.GLOBAL.DOCUMENTO.FACTURA_ELECTRONICA) {

        const viewPRE = $("<a class='btn btn-sm btn-white' target='_blank' href='" + host + "/kubber/facturacion/api/v1/generate/" + empresa + "/" + data.uniqueid + "'><i class='fa-solid fa-file-pdf'></i> PRE FACTURA</a>");
        td.append(viewPRE);

        const enviarPRE = $("<button class='btn btn-sm btn-info' data-uniqueid='" + data.uniqueid + "'><i class='fa-solid fa-check'></i>EMITIR</button>");
        $(enviarPRE).on("click", function () { vm.reintentarFactura(data, this); });
        td.append(enviarPRE);
    }

    // INACTIVAR
    if (data.public_hasp == null) {
        const inactivarBtn = $("<button title='BORRAR FACTURA NO EMITIDA' class='btn btn-sm btn-danger'><i class='fa-solid fa-xmark'></i></button>");
        $(inactivarBtn).on("click", function () { vm.inactivarFactura(data, this); });
        td.append(inactivarBtn);
    }


};

export default colombia;